import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navLinks = [
    { name: 'About', id: 'about' },
    { name: 'Programs', id: 'programs' },
    { name: 'How It Works', id: 'how-it-works' },
    { name: 'FAQ', id: 'faq' },
    { name: 'Contact', id: 'contact' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 bg-gradient-to-r from-pink-100 via-purple-100 to-blue-100 backdrop-blur-md shadow-lg z-50 border-b-4 border-purple-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div 
            className="text-2xl md:text-3xl font-bold text-purple-600 cursor-pointer hover:scale-110 transition-transform duration-300"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            Hola Spanglish
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="text-purple-600 hover:text-pink-500 font-semibold transition-colors duration-300 hover:scale-110 transform"
              >
                {link.name}
              </button>
            ))}
          </nav>

          {/* CTA Button - Desktop */}
          <div className="hidden md:block">
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-pink-300 to-purple-300 hover:from-pink-400 hover:to-purple-400 text-purple-700 font-bold px-6 py-3 rounded-full transition-all duration-300 hover:shadow-xl hover:scale-105 border-2 border-purple-200"
            >
              Book a Session
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-purple-600 hover:text-pink-500 transition-colors duration-300"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t-2 border-purple-200 animate-in slide-in-from-top duration-300 bg-gradient-to-b from-pink-50 to-purple-50 rounded-b-2xl">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="text-purple-600 hover:text-pink-500 font-semibold text-left py-2 px-4 transition-colors duration-300 hover:bg-purple-100 rounded-lg"
                >
                  {link.name}
                </button>
              ))}
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-pink-300 to-purple-300 hover:from-pink-400 hover:to-purple-400 text-purple-700 font-bold w-full mt-2 rounded-full border-2 border-purple-200"
              >
                Book a Session
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
